import React, { memo } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { Grid } from 'src/components/HTKit/Grid';
import styles from './styles.scss';

const ProductSpecifications = ({ className, data = [] }) => {
  const itemStyles = cn('paddingY-small paddingX-small1', styles.item);
  const textStyles = cn('p1 n900', styles.text);
  const textStylesAlt = cn('p1 n700 paddingLeft-small1', styles.text);
  return (
    <section className={styles.container}>
      <Grid.Fluid classes={className}>
        <Grid.Row>
          <Grid.Column sm={4} md={8} lg={6} lgOffset={3}>
            <h4 className="h4 n900 text-align-center marginBottom-medium">Product Specifications</h4>
            {data.map((item) => (
              <div key={item.id} className={itemStyles}>
                <p className={textStyles}>{item.title}</p>
                <p className={textStylesAlt}>{item.description}</p>
              </div>
            ))}
          </Grid.Column>
        </Grid.Row>
      </Grid.Fluid>
    </section>
  );
};

ProductSpecifications.propTypes = {
  className: PropTypes.string,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      title: PropTypes.string,
      description: PropTypes.string,
    }),
  ),
};

export default memo(ProductSpecifications);
